
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTwowayAcuatorGeneral10 as ObiTwowayAcuatorGeneral10Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-twoway-acuator-general-10.js';
 
 
 

 
 export const ObiTwowayAcuatorGeneral10 = createComponent({
   react: React,
   tagName: 'obi-twoway-acuator-general-10',
   elementClass: ObiTwowayAcuatorGeneral10Element,
   events: {
     
   }
  });
 
 